import { Button, MyLink } from '../ui-kit';
import { useWindowSizing } from '@app/hooks/useSizeWindow';
import classNames from 'classnames';

import styles from './EmptyListStub.module.scss';

interface IProps {
  title: string;
  textBtn?: string;
  idTextBtn?: string;
  href?: string;
  img?: React.ReactNode;
  text?: React.ReactNode;
  showBtn?: boolean;
  showBtnText?: string;
  idShowBtnText?: string;
  here?: string;
  className?: string;
}

export const EmptyListStub = ({ title, textBtn, idTextBtn, href, img, text, showBtn, showBtnText, idShowBtnText, here, className }: IProps) => {
  const isMobile = useWindowSizing(990);
  return (
    <div className={classNames(styles.Wrapper, className)}>
      <div>
        <div className={styles.Title}>{title}</div>
        {text && isMobile && (
          <div className={styles.Text}>
            {text}
            {here && (
              <MyLink href={href}>
                <span className={styles.Here}>{here}</span>
              </MyLink>
            )}
          </div>
        )}
        {isMobile && <div className={styles.MobileImg}>{img}</div>}
        {text && !isMobile && (
          <div className={styles.Text}>
            {text}
            {here && (
              <MyLink href={href}>
                <span className={styles.Here}>{here}.</span>
              </MyLink>
            )}
          </div>
        )}
        {textBtn && (
          <MyLink href={href}>
            <Button id={idTextBtn}>{textBtn}</Button>
          </MyLink>
        )}
        {showBtn && isMobile && (
          <MyLink href={href}>
            <Button id={idShowBtnText}>{showBtnText}</Button>
          </MyLink>
        )}
      </div>
      {!isMobile && <div>{img}</div>}
    </div>
  );
};
